import { store } from 'MainApp';

export default (action, emit, next, dispatch) => {
	try {
		const authToken = store.getState().auth.authUser;
		emit('action', { ...action, payload: { ...action.payload, authToken: authToken } });
		next(action);
	} catch (err) {
		console.log(err);
	}
};



// WEBPACK FOOTER //
// ./store/middleware.js